// extracted by css-extract-rspack-plugin
export default {"cls1":"NewsInteractionBar-cls1_fUq","cls2":"NewsInteractionBar-cls2_tIC NewsInteractionBar-cls1_fUq","variant-dense":"NewsInteractionBar-variant-dense_UhI"};